import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  CardHeader,
} from "reactstrap";
import Select from "react-select";
import TableContainer from "../../../../components/Common/TableContainer";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { useFormik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchCategories, fetchGracePolicyRequest, saveGracePolicyRequest } from "store/actions";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";
import CustomSelect from "components/Common/custom-select";

const Gracepolicy = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete } = useButtonAccess(accessRight);
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const {
    categories,
    gracePolicy,
    loading,
    error,
    success
  } = useSelector((state) => ({
    categories: state.CategoryMaster?.categories ?? [],
    gracePolicy: state.EmpGracePolicyReducer?.gracePolicy ?? [],

    loading: state.CategoryMaster?.loading || state.DepartmentMaster?.loading,
    error: state.CategoryMaster?.error || state.DepartmentMaster?.error,
    success: state.EmpGracePolicyReducer?.success,
  }));

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchCategories(unitId));
    dispatch(fetchGracePolicyRequest(unitId));
  }, [dispatch]);



  const [data, setData] = useState([
    {
      id: 1,
      employeeCategory: "Manager",
      graceTime: 15,
      freeLate: 0,
      withFine: 0,
      fineTimeLimit: 0,
      permissionTimeLimit: 0,
      leaveTimeLimit: 0,
      applicableFrom: "12/7/2024",
    },
    {
      id: 2,
      employeeCategory: "Staff",
      graceTime: 5,
      freeLate: 0,
      withFine: 0,
      fineTimeLimit: 0,
      permissionTimeLimit: 0,
      leaveTimeLimit: 0,
      applicableFrom: "2/5/2024",
    },
    {
      id: 3,
      employeeCategory: "Supervisor",
      graceTime: 10,
      freeLate: 2,
      withFine: 5,
      fineTimeLimit: 15,
      permissionTimeLimit: 10,
      leaveTimeLimit: 8,
      applicableFrom: "6/5/2024",
    },
    {
      id: 4,
      employeeCategory: "Executive",
      graceTime: 8,
      freeLate: 1,
      withFine: 3,
      fineTimeLimit: 10,
      permissionTimeLimit: 7,
      leaveTimeLimit: 5,
      applicableFrom: "3/7/2024",
    },
    {
      id: 5,
      employeeCategory: "Intern",
      graceTime: 5,
      freeLate: 0,
      withFine: 2,
      fineTimeLimit: 8,
      permissionTimeLimit: 5,
      leaveTimeLimit: 3,
      applicableFrom: "12/5/2024",
    },
  ]);

  const [isGracePunchEnabled, setGracePunchEnabled] = useState(false);
  const [searchCategory, setSearchCategory] = useState(null);

    useEffect(() => {
    if (success) {
      dispatch(fetchGracePolicyRequest(authDetails?.unit_id));
      formik.resetForm();
      setGracePunchEnabled(false)
    }
  }, [authDetails, success, dispatch]);

  // const employeeOptions = [
  //   { value: "Manager", label: "Manager" },
  //   { value: "Staff", label: "Staff" },
  //   { value: "Supervisor", label: "Supervisor" },
  //   { value: "Executive", label: "Executive" },
  //   { value: "Intern", label: "Intern" },
  // ];

  const employeeOptions = categories.map(cat => ({
    value: cat.empCatgryid.toString(), // store only string value in Formik
    label: cat.empCategory
  }));

  const formik = useFormik({
    initialValues: {
      employeeCategory: null,
      graceTime: "",
      freeLateLimit: "",
      withFine: "",
      timeWithFine: "", // Ensure this field is included
      permissionTime: "",
      leaveTime: "",
    },

    validationSchema: Yup.object({
      employeeCategory: Yup.string()
        .nullable()
        .required("Please select Employee Category"),
      graceTime: Yup.number()
        .required("Please enter Grace Time")
        .min(0, "Must be greater than or equal to 0").max(999, "Must be greater than or equal to 999"),
      permissionTime: Yup.number()
        .required("Please enter Permission Time")
        .min(0, "Must be greater than or equal to 0").max(999, "Must be greater than or equal to 999"),
      freeLateLimit: Yup.number()
        .required("Please enter Free Late Limit")
        .min(0, "Must be greater than or equal to 0").max(999, "Must be greater than or equal to 999"),
      timeWithFine: Yup.number()
        .required("Please enter Time With Fine")
        .min(0, "Must be greater than or equal to 0").max(999, "Must be greater than or equal to 999"),
      leaveTime: Yup.number()
        .required("Please enter Leave Time")
        .min(0, "Must be greater than or equal to 0").max(999, "Must be greater than or equal to 999"),
      withFine: Yup.number()
        .required("Please enter With Fine")
        .min(0, "Must be greater than or equal to 0").max(999, "Must be greater than or equal to 999"),
 
    }),
    onSubmit: (values) => {
      // console.log('values > ', values)
      const payload = new FormData();
      payload.append("emp_cat_id", values.employeeCategory);
      payload.append("time_limit", values.graceTime);
      payload.append("free_late", values.freeLateLimit);
      payload.append("with_fine", values.withFine);
      payload.append("fine_time_limit", values.timeWithFine);
      payload.append("permn_time_limit", values.permissionTime);
      payload.append("lve_time_limit", values.leaveTime);
      payload.append("unit_id", authDetails?.unit_id);
      payload.append("create_by", authDetails?.user_id);
      dispatch(saveGracePolicyRequest(payload))
      // const newData = [
      //   ...data,
      //   {
      //     id: data.length + 1,
      //     employeeCategory: values.employeeCategory,
      //     graceTime: values.graceTime,
      //     freeLate: values.freeLateLimit,
      //     withFine: values.withFine,
      //     fineTimeLimit: values.timeWithFine, // Map Time With Fine to Fine Time Limit
      //     permissionTimeLimit: values.permissionTime,
      //     leaveTimeLimit: values.leaveTime,
      //     applicableFrom: new Date().toLocaleDateString(),
      //   },
      // ];
      // // setData(newData);
      // // setFilteredData(newData); // Update table data
      // formik.resetForm();
    },

  });

  const columns = [
    { Header: "S No", Cell: ({ row }) => gracePolicy.length - row.index },
    { Header: "Employee Category", accessor: "employee_category" },
    { Header: "Grace Time (minutes)", accessor: "grace_time" },
    { Header: "Free Late", accessor: "free_late" },
    { Header: "With Fine", accessor: "with_fine" },
    { Header: "Fine Time Limit (minutes)", accessor: "fine_time_limit" }, // Map to fineTimeLimit
    { Header: "Permission Time Limit (minutes)", accessor: "permission_time_limit" },
    { Header: "Leave Time Limit (minutes)", accessor: "leave_time_limit" },
    { Header: "Applicable From", accessor: "applicable_from" },
  ];


  const [filteredData, setFilteredData] = useState(data);
  const handleSearch = () => {
    if (searchCategory) {
      const filtered = data.filter(
        (item) => item.employeeCategory === searchCategory.value
      );
      setFilteredData(filtered);
    } else {
      setFilteredData(data); // Ensure the latest data is shown
    }
  };

  // select custome style
  const SelectcustomStyles = {
    control: (base) => ({
      ...base,
      maxheight: 33.1,
      minHeight: 33.1,
      // overflow: "scroll",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      padding: "0", // Match the padding for both dropdown and clear indicator
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Ensure consistent padding for dropdown indicator
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Adjust padding for clear indicator to match dropdown
    }),
  };

  const handleCancel = async (e) => {
  e.preventDefault();
 
  // If no changes made, reset directly
  if (!formik.dirty) {
    formik.resetForm();
    return;
  }
 
  const result = await Swal.fire({
    title: "Confirm Cancel",
    text: "All entered data will be cleared. Do you want to continue?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Confirm",
    cancelButtonText: "Cancel",
    confirmButtonColor: "rgb(145, 73, 234)"
,
    cancelButtonColor: "#6c757d",
  });
 
  if (result.isConfirmed) {
    formik.resetForm();
 
    // Optional success message
    Swal.fire({
      icon: "success",
      title: "Cancelled",
      text: "Form data has been cleared",
      timer: 1500,
      showConfirmButton: false,
    });
  }
};



  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Policy Setup" breadcrumbItem="Grace Policy" />
          {(canRead && canCreate) && (
          <Card>
            <CardBody>
              <Form onSubmit={formik.handleSubmit}>
                <Row className="gy-3">
                  <Col md="12">
                    <Row md="3" className="d-flex flex-column align-items-center">
                      <FormGroup>
                        <Label for="employeeCategory">
                          Employee Category <span className="text-danger">*</span>
                        </Label>
                        <CustomSelect
                          id="employeeCategory"
                          name="employeeCategory"
                          options={employeeOptions}
                          value={
                            employeeOptions.find(
                              (opt) => opt.value === formik.values.employeeCategory
                            ) || null
                          }
                          onChange={(selectedOption) => {
                            const val = selectedOption ? selectedOption.value : null;
                            formik.setFieldValue("employeeCategory", val);

                            if (!val) {
                              setGracePunchEnabled(false);
                            }
                          }}
                        />
                        {formik.touched.employeeCategory && formik.errors.employeeCategory && (
                          <div className="text-danger">{formik.errors.employeeCategory}</div>
                        )}
                      </FormGroup>
                    </Row>

                  </Col>

                  <Col md="12">
                    {/* <Card className="border rounded shadow-sm p-3"> */}
                    <CardHeader className="bg-light d-flex justify-content-between align-items-center pd-select">
                      {/* <h5 className="mb-0">Grace Punch Settings</h5> */}
                      <FormGroup check className="m-0">
                        <Label check htmlFor="gracePunchTime" className="d-flex align-items-center gap-2 m-0">
                          <Input
                            type="checkbox"
                            id="gracePunchTime"
                            checked={isGracePunchEnabled}
                            onChange={(e) => {
                              const checked = e.target.checked;

                              // ✅ Validate only when trying to enable (check) the box
                              if (checked && !formik.values.employeeCategory) {
                                Swal.fire({
                                  icon: "warning",
                                  title: "Employee Category Required",
                                  text: "Please select an Employee Category before enabling Grace Punch Time.",
                                });
                                return; // ❌ Block checking if employee category not selected
                              }

                              // ✅ Proceed to update checkbox state
                              setGracePunchEnabled(checked);
                            }}
                          />
                          Grace Punch Time
                        </Label>
                      </FormGroup>

                    </CardHeader>

                    {isGracePunchEnabled && (
                      <CardBody>
                        <Row>
                          <Col md="6">
                            <FormGroup>
                              <Label for="graceTime">
                                Grace Time (minutes) <span className="text-danger">*</span>
                              </Label>
                              <Input
                                type="number"
                                id="graceTime"
                                name="graceTime"
                                maxLength={3}
                                value={formik.values.graceTime}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                className={
                                  formik.touched.graceTime && formik.errors.graceTime
                                    ? "is-invalid"
                                    : ""
                                }
                              />
                              {formik.touched.graceTime && formik.errors.graceTime && (
                                <div className="text-danger">{formik.errors.graceTime}</div>
                              )}
                            </FormGroup>

                            <FormGroup>
                              <Label for="permissionTime">
                                Permission Time (minutes) <span className="text-danger">*</span>
                              </Label>
                              <Input
                                type="number"
                                id="permissionTime"
                                name="permissionTime"
                                maxLength={3}
                                value={formik.values.permissionTime}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                className={
                                  formik.touched.permissionTime && formik.errors.permissionTime
                                    ? "is-invalid"
                                    : ""
                                }
                              />
                              {formik.touched.permissionTime && formik.errors.permissionTime && (
                                <div className="text-danger">{formik.errors.permissionTime}</div>
                              )}
                            </FormGroup>

                            <FormGroup>
                              <Label for="freeLateLimit">
                                Free Late Limit <span className="text-danger">*</span>
                              </Label>
                              <Input
                                type="number"
                                id="freeLateLimit"
                                name="freeLateLimit"
                                maxLength={3}
                                value={formik.values.freeLateLimit}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                className={
                                  formik.touched.freeLateLimit && formik.errors.freeLateLimit
                                    ? "is-invalid"
                                    : ""
                                }
                              />
                              {formik.touched.freeLateLimit && formik.errors.freeLateLimit && (
                                <div className="text-danger">{formik.errors.freeLateLimit}</div>
                              )}
                            </FormGroup>
                          </Col>

                          <Col md="6">
                            <FormGroup>
                              <Label for="timeWithFine">
                                Time With Fine (minutes) <span className="text-danger">*</span>
                              </Label>
                              <Input
                                type="number"
                                id="timeWithFine"
                                name="timeWithFine"
                                value={formik.values.timeWithFine}
                                maxLength={3}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                className={
                                  formik.touched.timeWithFine && formik.errors.timeWithFine
                                    ? "is-invalid"
                                    : ""
                                }
                              />
                              {formik.touched.timeWithFine && formik.errors.timeWithFine && (
                                <div className="text-danger">{formik.errors.timeWithFine}</div>
                              )}
                            </FormGroup>

                            <FormGroup>
                              <Label for="leaveTime">
                                Leave Time (minutes) <span className="text-danger">*</span>
                              </Label>
                              <Input
                                type="number"
                                id="leaveTime"
                                name="leaveTime"
                                value={formik.values.leaveTime}
                                maxLength={3}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                className={
                                  formik.touched.leaveTime && formik.errors.leaveTime
                                    ? "is-invalid"
                                    : ""
                                }
                              />
                              {formik.touched.leaveTime && formik.errors.leaveTime && (
                                <div className="text-danger">{formik.errors.leaveTime}</div>
                              )}
                            </FormGroup>

                            <FormGroup>
                              <Label for="withFine">
                                With Fine <span className="text-danger">*</span>
                              </Label>
                              <Input
                                type="number"
                                id="withFine"
                                name="withFine"
                                maxLength={3}
                                value={formik.values.withFine}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                className={
                                  formik.touched.withFine && formik.errors.withFine
                                    ? "is-invalid"
                                    : ""
                                }
                              />
                              {formik.touched.withFine && formik.errors.withFine && (
                                <div className="text-danger">{formik.errors.withFine}</div>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                      </CardBody>
                    )}
                    {/* </Card> */}
                  </Col>

                  <Col md="12" className="text-end mob-center">
                    <Button type="submit" className="btn button-save  me-2">
                      <i className="fas fa-save me-1" /> Save
                    </Button>
                   <Button
                      type="button"
                      onClick={handleCancel}
                      className="btn button-cancel"
                    >
                      <i className="fas fa-sync me-1" /> Cancel
                    </Button>

                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
          )}
          {canRead && (

          <Card className="mt-4">
            <CardBody>
              {/* <Row className="mb-3 align-items-center">
                <Col md="4">
                  <FormGroup>
                    <Label for="searchCategory">Employee Category</Label>
                    <Select
                      styles={SelectcustomStyles}
                      id="searchCategory"
                      options={employeeOptions}
                      isClearable
                      value={searchCategory}
                      onChange={setSearchCategory}
                    />
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <Label for="policy">Policy</Label>
                    <Input type="text" id="policy" defaultValue="Grace Punch" disabled />
                  </FormGroup>
                </Col>
                <Col md="4" className="mt-2">
                  <Button color="primary" onClick={handleSearch}>
                    <i className="mdi mdi-magnify me-2 fs-16"></i>
                    Search
                  </Button>
                </Col>
              </Row> */}

              <TableContainer
                columns={columns}
                data={gracePolicy.length > 0 ? gracePolicy : []} // Use filteredData instead of data
                isGlobalFilter={true}
                customPageSize={10}
              />

            </CardBody>
          </Card>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Gracepolicy;
